// Tremor Textarea [v0.0.2]

import React from "react";

import { cx, focusInput, hasErrorInput } from "../utils";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, hasError, ...props }: TextareaProps, forwardedRef) => {
    return (
      <textarea
        ref={forwardedRef}
        className={cx(
          // base
          "flex min-h-[4rem] w-full rounded-md border px-3 py-1.5 shadow-sm outline-none transition-colors sm:text-sm",
          // border color
          "border-borderPrimary",
          // text color
          "text-secondary",
          // placeholder color
          "placeholder-gray-500",
          // background color
          "dark:bg-secondaryBg ",
          // disabled

          "disabled:dark:border-zinc-800 disabled:dark:bg-zinc-900 disabled:dark:text-secondary",
          // focus
          focusInput,
          // error
          hasError ? hasErrorInput : "",
          // invalid (optional)
          // "aria-[invalid=true]:dark:ring-red-400/20 aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-red-200 aria-[invalid=true]:border-red-500 invalid:ring-2 invalid:ring-red-200 invalid:border-red-500"
          className
        )}
        tremor-id="tremor-raw"
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea, type TextareaProps };
